// src/store/index.js
import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './rootSaga';

// Import your reducers here:
import userReducer from './user/userSlice';
// import otherReducer from './someOtherSlice/otherSlice';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    user: userReducer,
    // otherState: otherReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // turn off the default "thunk" if you want
      thunk: false,
      // or keep it if you have other usage
    }).concat(sagaMiddleware),
});

// Run the root saga
sagaMiddleware.run(rootSaga);

export default store;
